import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const InventoryTransactionSummaryViewModule = new Module({
  id: 'INVENTORY-TRANSACTION-SUMMARY-REPORT:VIEW:*',
  name: 'Inventory Transaction Summary',
  label: 'Inventory Transaction Summary',
  path: 'inventory-transaction-summary',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/InventoryTransactionSummary'))
  ),
  actions: {
    viewDetails: {
      id: 'INVENTORY-TRANSACTION-SUMMARY-REPORT:VIEW:DETAILS',
      name: 'view-details',
      label: 'View Details'
    }
  }
});

const InventoryTransactionSummaryModules = [
  InventoryTransactionSummaryViewModule
];

export default new ModuleBundle(
  'InventoryTransactionSummary',
  InventoryTransactionSummaryModules
);
